import { useState } from 'react';

interface Props {
  children: React.ReactNode;
}

export function InfoToggle({ children }: Props) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        className="info-toggle-btn"
        onClick={() => setOpen((v) => !v)}
        aria-label={open ? 'Hide description' : 'Show description'}
        title={open ? 'Hide description' : 'Show description'}
      >
        i
      </button>
      {open && <div className="info-toggle-body">{children}</div>}
    </>
  );
}
